import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import Checkout from "@system/config/checkout";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import liveAuth from 'src/helper/liveAuth';
import System from 'src/helper/system';
import { useCartStore } from 'src/hooks/cart';
import { isNumber } from 'underscore';
import Helper from 'src/support/Helper';
import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import getSymbolFromCurrency from "currency-symbol-map";
import Constants from 'src/support/Constants';
import { Tooltip } from 'src/component/Tooltip';
import infoCircle from 'src/assets/images/info-circle.png'
import ReusableDiv from 'src/support/ReusableDiv';
const c = System.getParams();

const QuoteCartShippingDetail = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const CART_SHIPPING_ADDRESS_ID = useSelector((state) => state.entities.Cart.CART_SHIPPING_ADDRESS_ID);
    const [{ get_current_quote_cart }, { }, { }] = useQuoteDetailStore();
    const [{ QUOTE_CART_BLACKLISTED_ARR }, { get_quote_currency, get_quote_cart_subtotal, get_cart_quote, get_cart_quote_number }, { }] = useCartStore();
    const quoteList = get_current_quote_cart();
    const quoteNumber = get_cart_quote_number();
    const quoteCurrency = get_quote_currency(quoteList);
    const subTotal = get_quote_cart_subtotal(quoteList);
    // const CALCULATED_VAT_DATA = 0;
    const [load, setLoad] = useState(false)


    // useEffect(() => {
    //     async function fetchHere() {
    //         // if (quoteList !== undefined && Object.entries(quoteList).length > 0 && isNumber(parseInt(VAT_DATA)) && parseInt(VAT_DATA) > 0) {
    //         if (quoteList !== undefined && Object.entries(quoteList).length > 0) {
    //             await get_quote_cart_subtotal(quoteList)
    //             let cart_detail = {};
    //             cart_detail['cart_data'] = quoteList;
    //             //cart_detail['vat_data'] = parseInt(VAT_DATA)
    //             await get_quote_calculated_vat_data(cart_detail)
    //         }
    //     }

    //     fetchHere()
    // }, [quoteList, VAT_DATA]);

    const authLoggedIn = (keyIndex) => {
        return liveAuth.check();
    };

    const checkOutButtonDisable = () => {
        if (!(quoteList && Object.entries(quoteList).length > 0)) {
            return true;
        }
        // Story # : 16231 Description : Quote Cart Vendor exclusion commented Date : 30 April 2024
        // if(QUOTE_CART_BLACKLISTED_ARR && QUOTE_CART_BLACKLISTED_ARR?.length > 0 &&
        //     QUOTE_CART_BLACKLISTED_ARR?.filter(x => x?.isVendorExcluded === true).length > 0)
        // {
        //     return true;
        // }
        if (authLoggedIn() === false) {
            return false;
        }
        return false;
    };

    const checkOutAction = (onlyAction = true) => {
        if (authLoggedIn() === false) {
            System.popup('GuestPopupActionButton', { title: 'Sign In', body: 'Sign In to continue with Avnet' });
            return;
        }

        if (shippingModalDecisionMaker() === true) {
            System.popup('ShippingAddressPopup');
            return;
        }

        if (onlyAction === true) {
            setLoad(true);
            window.location.href = Checkout.getCheckOutRouteURL() + '?quote_number=' + quoteNumber;
        }
    };

    const shippingModalDecisionMaker = () => {
        if (Helper.valueIsNotNull(CART_SHIPPING_ADDRESS_ID) === false || CART_SHIPPING_ADDRESS_ID === false || CART_SHIPPING_ADDRESS_ID === 0) {
            return true;
        }
        return false;
    }

    const renderItemSubTotal = (props) => (
        <div className="col-12">
            <div className="bs5 row m-0 mini-cart-item-total">
                <div className="col-7 px-0">
                    <span className="cart-item-count">
                        ({Object.entries(quoteList).length}){" "}
                    </span>
                    Items Subtotal:
                </div>
                <div className="col-5 text-end font_bold_currency ps-1">
                    <span className="font_bold_currency">
                        {isNumber(subTotal)
                            ? Helper.getFormatNumber(Number(subTotal), quoteCurrency, getSymbolFromCurrency(quoteCurrency))
                            : ""}
                    </span>
                </div>
            </div>
        </div>
    );

    const renderOrderTotal = (props) => (
        <>
            <span className='subtotal-currency'>{quoteCurrency} </span>
            <span>
                {isNumber(subTotal)
                    ? Helper.getFormatNumber(Number(subTotal), quoteCurrency, getSymbolFromCurrency(quoteCurrency)) : ""}
            </span>
        </>
    );

    const getVatData = () => {
        let vat_val = "--"
        // if (CART_SHIPPING_ADDRESS_ID && isNumber(CALCULATED_VAT_DATA) && Number(CALCULATED_VAT_DATA) > 0) {
        //     vat_val = isNumber(CALCULATED_VAT_DATA)
        //         ? Helper.getFormatNumber(Number(CALCULATED_VAT_DATA), quoteCurrency, getSymbolFromCurrency(quoteCurrency))
        //         : "";
        //     // vat_val = isNumber(CALCULATED_VAT_DATA) ? new Intl.NumberFormat(Helper.getCurrencyFormat(window.mct), {
        //     //     style: 'currency',
        //     //     currency: window.mct
        //     // }).format(CALCULATED_VAT_DATA).replace(/\s/g, "") : '';
        // }
        return vat_val;
    }

    return (
        <>
            {props.summaryFor === Constants.systemModules.CART &&
                <div className="cart-shopping-detail">
                    <div className="cart-shipping-detail">
                        <div className="bs5 row">
                            {renderItemSubTotal()}
                        </div>
                        <div className="bs5 row">
                            <div className="col-7"><span>Estimated Shipping: </span>
                                <Tooltip
                                    opener={() => (<img src={infoCircle} />)}
                                    content={() => ReusableDiv.EstimatedShippingTooltip()}
                                />
                            </div>
                            <div className="col-5 text-end font_bold_currency"><span>--</span></div>
                        </div>
                        {authLoggedIn() &&
                            <div className="bs5 row font_bold_currency">
                                <div className="col-7"><span>Estimated VAT: </span></div>
                                <div className="col-5 text-end ">
                                    {getVatData()}
                                </div>
                            </div>
                        }
                    </div>
                    <div className="bs5 row m-0 mini-cart-item-total">
                        <div className="order-total">
                            <div className="bs5 row font_bold_currency">
                                <div className="col-7">
                                    Order Total:
                                </div>
                                <div className="col-5 text-end ">
                                    {renderOrderTotal()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="shopping-option text-center">
                        {(CART_SHIPPING_ADDRESS_ID || CART_SHIPPING_ADDRESS_ID > 0) &&
                            __check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status &&
                            <a href={void (0)} className="bs5 btn btn-primary d-block most-viewd-item-btn m-auto" >
                                <i className="fa add-cart-spinner fa-spin" />
                            </a>
                        }
                        <a href={void (0)}
                            onClick={(e) => { load ? e.preventDefault() : !checkOutButtonDisable() && checkOutAction() }}
                            disabled={checkOutButtonDisable()}
                            className={`bs5 btn btn-primary d-block most-viewd-item-btn m-auto mb-2 ${load && 'h-30'}`}
                        >
                            <div className='d-flex align-items-center justify-content-center line-height-20'>
                                {load &&
                                    <div>
                                        <i className="fa add-cart-spinner fa-spin" />
                                    </div>
                                }
                                {!load &&
                                    <>
                                        <span className="fa add-cart-lock-icon me-1" /> Checkout
                                    </>
                                }
                            </div>
                        </a>
                        <span className="instruction text-black-stone">VAT and shipping will be calculated later</span>
                    </div>
                </div>
            }
            {props.summaryFor === Constants.systemModules.CHECKOUT &&
                <>
                    <div className="p-15">
                        <div className="bs5 row mb-1">
                            {renderItemSubTotal()}
                        </div>
                        <div className="bs5 row mb-1">
                            <div className="col-8"><span className='me-1'>Estimated Shipping:</span>
                                <Tooltip
                                    opener={() => (<img src={infoCircle} />)}
                                    content={() => ReusableDiv.EstimatedShippingTooltip()}
                                />
                            </div>
                            <div className="col-4 text-end"><b>--</b></div>
                        </div>
                        <div className="bs5 row mb-1">
                            <div className="col-8">Estimated VAT: </div>
                            <div className="col-4 text-end">
                                {getVatData()}
                            </div>
                        </div>
                    </div>
                    <div className="bs5 row total-row m-0">
                        <div className="col-6">

                            <b>Order Total :</b>
                        </div>
                        <div className="col-6 text-end font_bold_currency ps-1">
                            {renderOrderTotal()}
                        </div>
                    </div>
                </>
            }
        </>
    );
}

export default QuoteCartShippingDetail;